import { render, staticRenderFns } from "./AttestationLangSwitch.vue?vue&type=template&id=1053d88a&scoped=true&"
import script from "./AttestationLangSwitch.vue?vue&type=script&lang=js&"
export * from "./AttestationLangSwitch.vue?vue&type=script&lang=js&"
import style0 from "./AttestationLangSwitch.vue?vue&type=style&index=0&id=1053d88a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1053d88a",
  null
  
)

export default component.exports